"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PROGRESS_TTL = void 0;
exports.restorable = restorable;
exports.PROGRESS_TTL = 60 * 60_000;
function restorable(progress, size, now) {
    return !!progress && !progress.solved && now >= progress.savedAt && now - progress.savedAt < exports.PROGRESS_TTL
        && typeof progress.activityId === 'string' && Array.isArray(progress.placed) && Array.isArray(progress.order)
        && progress.order.length === size * size && new Set(progress.order).size === size * size
        && progress.order.every(id => Number.isInteger(id) && id >= 0 && id < size * size)
        && new Set(progress.placed).size === progress.placed.length && progress.placed.length < size * size
        && progress.placed.every(id => progress.order.includes(id));
}
//# sourceMappingURL=progress.js.map